import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';
import Pipe from './../Pipe/Pipe.jsx';
import { ReactComponent as ExperimentIcon } from '../../icons/svg/experiment.svg';
import { ReactComponent as ExperimentBubbleLargeIcon } from '../../icons/svg/experiment-bubble-large.svg';
import { ReactComponent as ExperimentBubbleSmallIcon } from '../../icons/svg/experiment-bubble-small.svg';
import { ReactComponent as EnvelopeIcon } from '../../icons/svg/envelope.svg';
import { ReactComponent as LightBulbNoRaysIcon } from '../../icons/svg/light-bulb-no-rays.svg';
import { ReactComponent as LightBulbRaysIcon } from '../../icons/svg/light-bulb-rays.svg';

export default class OverlappingContentBox extends NrgComponent {

  render() {
    return (
      <div className="OverlappingContentBox row">
        <div className="col-xs-16">
          <div className="void top left"></div>
          <div className="void top right"></div>
          <div className="inner">
            <div className="content">
              <Pipe additionalClassName="one" scrollProgressType="pipe" />
              <div className="row statement">
                <div className="col-xs-16">
                  <div className="text experiment">
                    <h3 data-scroll-item-once>{Content[this.props.page].line1}</h3>
                  </div>
                  <div className="icon experiment" data-scroll-item-once="experiment">
                    <ExperimentIcon className="experiment-beaker" viewBox="0 0 60 60"></ExperimentIcon>
                    <ExperimentBubbleLargeIcon className="experiment-bubble-large" viewBox="0 0 60 60"></ExperimentBubbleLargeIcon>
                    <ExperimentBubbleSmallIcon className="experiment-bubble-small" viewBox="0 0 60 60"></ExperimentBubbleSmallIcon>
                  </div>
                </div>
              </div>
              <Pipe additionalClassName="two" scrollProgressType="pipe" />
              <div className="row statement">
                <div className="col-xs-16">
                  <div className="text envelope">
                    <h3 data-scroll-item-once>{Content[this.props.page].line2}</h3>
                  </div>
                  <div className="icon envelope" data-scroll-item-once="envelope">
                    <EnvelopeIcon viewBox="0 0 150 150"></EnvelopeIcon>
                  </div>
                </div>
              </div>
              <Pipe additionalClassName="three" scrollProgressType="pipe" />
              <div className="row statement">
                <div className="col-xs-16">
                  <div className="text">
                    <h3 data-scroll-item-once>{Content[this.props.page].line3}</h3>
                  </div>
                </div>
              </div>
              <Pipe additionalClassName="four" scrollProgressType="pipe" />
              <div className="row statement last">
                <div className="col-xs-16">
                  <div className="text light-bulb">
                    <h3 className="wider" data-scroll-item-once>{Content[this.props.page].line4}</h3>
                  </div>
                  <div className="icon light-bulb" data-scroll-item-once="bulb">
                    <LightBulbNoRaysIcon className="bulb-no-rays" viewBox="0 0 195 195"></LightBulbNoRaysIcon>
                    <LightBulbRaysIcon className="bulb-rays" viewBox="0 0 195 195"></LightBulbRaysIcon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="void bottom left"></div>
          <div className="void bottom right"></div>
        </div>
      </div>
    );
  }

};
